import { FC } from 'react';

import Button from 'molecules/Button';
import MarketoForm from 'molecules/Form';
import Image from 'molecules/Image';
import RichText from 'molecules/RichText';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import { ResourceDownloadCardConfigProps } from 'organisms/Cards/ResourceDownload/config';
import { resourceContainer } from 'organisms/Cards/ResourceDownload/styles';

import { useBuilderReference } from 'utils/hooks/useBuilderReference';

const ResourceDownloadCard: FC<ResourceDownloadCardConfigProps> = props => {
  const { sectionProps, rest } = splitSectionProps(props);
  const { heading, description, buttonLabel, resource, image, color, useForm, form, standalone } = rest;

  const safeColor = color === 'green' ? color : 'green';

  const hasPreloadedForm = !!form?.value?.data;
  const formRefData = useBuilderReference(
    !hasPreloadedForm ? form?.model : undefined,
    !hasPreloadedForm ? form?.id : undefined,
  );
  const formData = hasPreloadedForm ? form.value.data : formRefData;

  const card = (
    <div className={resourceContainer({ color: safeColor })}>
      {image?.file?.url && (
        <Image
          url={image.file.url}
          alt={image?.alt || 'resource'}
          className="h-[250px] w-full shrink-0 overflow-hidden rounded-lg sm:h-[250px] sm:w-40 lg:h-[250px] lg:w-48 [&_img]:object-contain"
          sizes="(max-width: 640px) 100vw, (max-width: 1024px) 260px, 320px"
          unsetRatio
          unsetMaxW
        />
      )}
      <div className="flex flex-col gap-4">
        {heading && (
          <div className="flex font-spaceGrotesk text-xl font-bold text-gray-1100 sm:text-display-xs">{heading}</div>
        )}
        {description && (
          <RichText text={description} className="text-md text-gray-1300 sm:text-lg">
            {description}
          </RichText>
        )}
        {useForm
          ? formData && (
              <div className="w-full">
                <MarketoForm
                  formData={formData as FormReference}
                  layout="inline"
                  successMessageClassName="text-md text-gray-1300 sm:text-lg"
                />
              </div>
            )
          : buttonLabel && (
              <Button
                label={buttonLabel}
                href={resource}
                hierarchy="primary"
                className="w-full !text-gray-900 sm:w-fit"
              />
            )}
      </div>
    </div>
  );

  return standalone ? <Section {...sectionProps}>{card}</Section> : card;
};

export default ResourceDownloadCard;
